import { useMediaQuery } from "./use-media-query";

/**
 * Hook to detect device type based on screen width.
 * All values are undefined during SSR/hydration.
 *
 * Breakpoints:
 * - Mobile: < 640px (sm)
 * - Tablet: 640px - 1023px
 * - Desktop: >= 1024px (lg)
 */
export function useMobile() {
  const isMobile = useMediaQuery("(max-width: 639px)");
  const isTablet = useMediaQuery("(min-width: 640px) and (max-width: 1023px)");
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  const isLoading = isMobile === undefined;

  return { isMobile, isTablet, isDesktop, isLoading };
}
